import Link from "next/link";
import React from "react";
import { CaraCerdasList } from "src/data/literasi-keuangan/CaraCerdasContent";

const CardComponentCaraCerdas = ({ relatedTo }) => {
  let itemsToDisplay = CaraCerdasList;
  if (relatedTo && relatedTo.length > 0) {
    itemsToDisplay = itemsToDisplay.filter(
      (item) => !relatedTo.includes(item.slug)
    );
  }
  return (
    <React.Fragment>
      {itemsToDisplay.map((item, index) => (
        <div className="CaraCerdas-card" key={index}>
          <div className="CaraCerdas-card-desc-container">
            <div className="CaraCerdas-card-icon-container">
              <img
                src={item.icon}
                alt={item.title}
                className="CaraCerdas-card-icon"
              />
            </div>
            <div className="CaraCerdas-card-description">
              <p className="CaraCerdas-card-title">{item.title}</p>
              <p className="CaraCerdas-card-subtitle">{item.cardsubtitle}</p>
            </div>
          </div>
          <div className="CaraCerdas-card-button-container">
            <Link href={item.link} legacyBehavior>
              <a data-cy="url-test">
                <div className="CaraCerdas-card-button">Lihat</div>
              </a>
            </Link>
          </div>
        </div>
      ))}
      <style jsx global>
        {`
          .CaraCerdas-card {
            display: flex;
            flex-direction: column;
            max-height: 387px;
            height: 387px;
            max-width: 218px;
            width: 218px;
            flex: 1;
            border-radius: 8.33px;
            background-color: var(--color-white);
            box-shadow: 0 3px 10px 0 var(--color-white-dark);
            margin-left: 7px;
            margin-right: 7px;
          }
          .CaraCerdas-card-icon-container {
            display: flex;
            justify-content: center;
            margin: 16px 0px;
            max-width: 80px;
            max-height: 80px;
          }
          .CaraCerdas-card-icon {
            width: 100%;
            height: 65px;
          }
          .CaraCerdas-card-desc-container {
            height: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            margin-top: 16px;
          }
          .CaraCerdas-card-description {
            min-height: 80px;
            padding: 12px;
            display: flex;
            flex-direction: column;
          }
          .CaraCerdas-card-title {
            font-weight: 700;
            font-size: 18px;
            margin: 0 0 8px;
            text-align: center;
            text-transform: capitalize;
          }
          .CaraCerdas-card-subtitle {
            font-weight: 400;
            font-size: 18px;
            margin: 0;
            text-align: center;
          }
          .CaraCerdas-card-button-container {
            margin-bottom: 24px;
          }
          .CaraCerdas-card-button {
            background-color: var(--color-red);
            color: var(--color-white);
            display: flex;
            padding: 10px;
            align-items: center;
            justify-content: center;
            border-radius: 24px;
            font-weight: bold;
            margin: 0px 50px;
          }
          @media only screen and (max-width: 600px) {
            .CaraCerdas-card {
              height: 340px;
              width: 160px;
              margin: 0px 7px;
            }
            .flickity-button-icon {
              fill: var(--color-red);
            }
            .flickity-prev-next-button {
              width: 35px;
              height: 35px;
            }
            .CaraCerdas-card-title {
              font-size: 16px;
            }
            .CaraCerdas-card-subtitle {
              font-size: 14px;
            }
            .CaraCerdas-card-description {
              min-height: 70px;
            }
            .CaraCerdas-card-desc-container {
              min-height: auto;
            }
            .CaraCerdas-card-button {
              font-size: 10px;
              padding: 5px 30px;
            }
          }
        `}
      </style>
    </React.Fragment>
  );
};

export default CardComponentCaraCerdas;
